import { useState } from "react";
const useChatUIState = ()=>{
    const [showSurvey, setShowSurvey] = useState(false);
    const [openErrorComponent, setOpenErrorComponent] = useState(false);
    const [isMapOpened, setIsMapOpened] = useState(false);
    return {
        showSurvey,
        setShowSurvey,
        openErrorComponent,
        setOpenErrorComponent,
        isMapOpened,
        setIsMapOpened
    };
};
export { useChatUIState };
